var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Layout',{attrs:{"fixHeader":true}},[_c('CompNav',{attrs:{"slot":"header"},slot:"header"},[_vm._v("header")]),_c('router-view')],1),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"fixed"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/#/Integrated/index"}},[_vm._v("Copyright ©2019 ,www.tobog.cn,All Rights Reserved. | 皖ICP备19017849号-1")])])
}]

export { render, staticRenderFns }